import { computed } from "vue";
import { useStore } from "vuex";
import authService from "@/services/AuthService";

export function useAuth() {
  const store = useStore();
  const isAuthenticated = computed(() => !!store.state.access_token);
  const currentUser = computed(() => authService.getCurrentUser());
  const accessToken = computed(() => store.state.access_token);

  const login = async (username, password) => {
    return await authService.login(username, password);
  };

  const logout = async () => {
    return await authService.logout();
  };

  return {
    // Reactive state
    isAuthenticated,
    currentUser,
    accessToken,

    // Methods
    login,
    logout,
  };
}
